// styles/buttonStyles.ts
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { type ButtonSize } from '@shared/models/components/ICoreButtonProps';
import { MixinFocusVisible } from '../structure/DefaultStyles';
import { TextSize100, TextSize200, TextSize90 } from '../text/Typography';

export const buttonBaseStyles = css`
    text-align: center;
    border-radius: 0.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
    position: relative;
    padding: 0.5rem 1rem;
    gap: 0.5rem;
    text-underline-offset: 0.15rem;
    @media (prefers-reduced-motion: no-preference) {
        transition: all 0.1s ease-out;
        & * {
            transition: ease-out 0.1s;
        }
    }
    transform-origin: center;
    ${MixinFocusVisible}
`;

export const sizeStyles: Record<ButtonSize, SerializedStyles> = {
    small: css`
        ${TextSize90}
        min-height: 2.5rem;
        padding: 0 0.625rem;
    `,
    medium: css`
        ${TextSize100}
        width: fit-content;
        max-width: 100%;
        padding: 0.625rem;
    `,
    large: css`
        ${TextSize200}
        width: 100%;
        padding: 0.875rem;
    `,
    quick: css`
        ${TextSize100}
        padding: 0.625rem 0.875rem;
    `,
};

export const aaaSizeStyles: Record<ButtonSize, SerializedStyles> = {
    small: css`
        ${TextSize90}
        min-height: 2.75rem;
        min-width: 44px;
        padding: 0 0.75rem;
    `,
    medium: css`
        ${TextSize100}
        min-width: 44px;
        min-height: 44px;
        width: fit-content;
        max-width: 100%;
        padding: 0.75rem;
    `,
    large: css`
        ${TextSize200}
        width: 100%;
        min-width: 44px;
        min-height: 44px;
        padding: 1rem;
    `,
    quick: css`
        ${TextSize100}
        min-width: 44px;
        min-height: 44px;
        padding: 0.75rem 1rem;
    `,
};

export const disabledButtonStyles = css`
    cursor: not-allowed;
    color: #666;
    background: #ccc;
    border-color: #666;
    &:hover {
        background: transparent;
        color: #666;
    }
`;

export const TabButton = styled.button<{ isActive: boolean }>`
    padding: 0.5rem 1rem;
    border: none;
    background: ${(props) => (props.isActive ? props.theme.color.accent : props.theme.color.cardHover)};
    color: ${(props) => (props.isActive ? props.theme.color.background : props.theme.button.secondary.text)};
    cursor: pointer;
    border-radius: 50px;
    transition: all 0.2s ease;
    &:hover {
        background: ${(props) => props.theme.button.secondary.text};
        color: ${(props) => props.theme.color.background};
    }
    ${MixinFocusVisible}
`;

export const TabContainer = styled.div`
    display: flex;
    gap: 10px;
    margin: 10px 0;
`;
